import React, { useState, useEffect, useRef, useLayoutEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import CustomModal from "../CustomModal";
import "../AssignSymbols/assignSymbols.scss";
import AccordionClaim from "./AccordionClaim";
import { updatSlideData, getAllScripts } from "../../services/apis";

const AssignsymbolPopup = ({
  OpenAssignPopup,
  setOpenAssignPopup,
  setAppledSymbol,
  footnoteSymbols,
  symbolAssigned,
  cancelPopup,
  claim,
  item,
  moduleClaimsData,
  relatedClaimsData,
  setRelatedClaimsData,
  setPreviewLoading,
  setSymbolsObjData,
  symbolsObjData,
  setAssignedSymbols,
  editor,
  appliedSymbol,
  previewLoading,
}) => {
  const [clickedSymbols, setClickedSymbols] = useState(null);
  const [updateList, setUpdateList] = useState(false);
  const { pageId } = useParams();
  useEffect(() => {
    getAllScripts(pageId, (response, err, errorCode) => {
      setPreviewLoading(true);
      if (err) {
        setPreviewLoading(false);
        // setIsloading(false);
      } else {
        // setIsloading(false);
        const selectedRelatedClaims = response?.data?.relatedClaimsData;
        setRelatedClaimsData([...selectedRelatedClaims]);
        setPreviewLoading(false);
      }
    });
  }, [OpenAssignPopup]);

  useLayoutEffect(() => {
    if (!previewLoading && relatedClaimsData) {
      // Runs after DOM updates but BEFORE painting
      setUpdateList(true);
    }
  }, [previewLoading, relatedClaimsData]);
  const selectSymbol = (icons) => {
    const obj = {
      relatedClaimId: item.claimName,
      text: "",
      symbol: icons,
      claimId: claim.claimName,
      moduleId: moduleClaimsData?.moduleDamName,
    };
    const claimExistArray = relatedClaimsData?.findIndex(
      (exist_claim) =>
        exist_claim.relatedClaimId === obj.relatedClaimId &&
        exist_claim.moduleId === obj.moduleId
    );
    if (claimExistArray > -1) {
      relatedClaimsData[claimExistArray] = obj;
    } else {
      //relatedClaimsData.push(obj);
    }
    //setRelatedClaimsData([...relatedClaimsData])
    setClickedSymbols(icons);
  };

  const assignSymbolsHandler = (symbol) => {
    setPreviewLoading(true);
    // console.log("existed clims array", relatedClaimsData);
    const obj = {
      relatedClaimId: item.claimName,
      text: "",
      symbol: symbol,
      claimId: claim.claimName,
      moduleId: moduleClaimsData?.moduleDamName,
    };
    const claimExistArray = relatedClaimsData?.findIndex(
      (exist_claim) =>
        exist_claim.relatedClaimId === obj.relatedClaimId &&
        exist_claim.moduleId === obj.moduleId
    );
    /*  if (symbolsObjData?.hasOwnProperty(item.claimName)) {
      symbolsObjData[item.claimName] = symbol;
    } else {
      symbolsObjData[item.claimName] = symbol;
    }
    setSymbolsObjData( symbolsObjData );
    const relatedClaimsArray = {
      moduleId: moduleClaimsData?.moduleDamName,
      moduleClaims: [
        {
          moduleClaimId: claim.claimName,
          relatedClaims: [
            {
              relatedClaimId: item.claimName,
              text: "",
              symbol: symbol,
            },
          ],
        },
      ],
    }; */
    /* const moduleExist = relatedClaimsData?.findIndex(
      (exist_claim) => exist_claim.moduleId === obj.moduleId
    );
    if (moduleExist > -1) {
      const claimExist = relatedClaimsData[moduleExist].moduleClaims.findIndex(
        (claim) => claim.moduleClaimId === obj.claimId
      );
      if (claimExist > -1) {
        const reClaimExist = relatedClaimsData[moduleExist].moduleClaims[
          claimExist
        ].relatedClaims.findIndex(
          (re_claim) => re_claim.relatedClaimId === obj.relatedClaimId
        );
        console.log("related claim", moduleExist, claimExist, reClaimExist);
        if (reClaimExist > -1) {
          relatedClaimsData[moduleExist].moduleClaims[claimExist].relatedClaims[
            reClaimExist
          ] = obj;
          console.log("esixted claim", reClaimExist);
        } else {
          console.log("not esixted claim", reClaimExist);
          relatedClaimsData[moduleExist].moduleClaims[
            claimExist
          ].relatedClaims.push(obj);
        }
      } else {
        const moduleObj = {
          moduleClaimId: claim.claimName,
          relatedClaims: [
            {
              relatedClaimId: item.claimName,
              text: "",
              symbol: symbol,
            },
          ],
        };
        relatedClaimsData[moduleExist].moduleClaims.push(moduleObj);
      }
      setRelatedClaimsData([...relatedClaimsData]);
      finalAssignment([...relatedClaimsData]);
    } else {
      setRelatedClaimsData([...relatedClaimsData, relatedClaimsArray]);
      finalAssignment([...relatedClaimsData, relatedClaimsArray]);
    } */
    // console.log(
    //   "selected symbol",
    //   item,
    //   obj,
    //   claim.claimName,
    //   moduleClaimsData?.moduleDamName
    // );
    if (claimExistArray > -1) {
      relatedClaimsData[claimExistArray] = obj;
    } else {
      relatedClaimsData.push(obj);
    }
    setRelatedClaimsData([...relatedClaimsData]);
    setAppledSymbol(symbol);
    const claimParentOnEditor = editor
      ?.getWrapper()
      .find(`[parent-claim=${claim.claimName}]`);

    const relateClaimOnEditor = editor
      ?.getWrapper()
      .find(`[claim-id=${item.claimName}]`);

    if (relateClaimOnEditor.length > 0) {
      for (var j = 0; j < relateClaimOnEditor.length; j++) {
        //symbolElements[j].set('content', symbol)
        let textNode = relateClaimOnEditor[j].components().at(0);
        // console.log(textNode, "symbol text");
        const styleObj = relateClaimOnEditor[j].getStyle();
        relateClaimOnEditor[j].replaceWith( {
          tagName: "sup",
          attributes: {
            "claim-id": item.claimName,
            
          },
          style: styleObj,
          content: symbol,
           editable: false, // prevents editing the sup element itself
          selectable: true, // allows selecting
          hoverable: true,
          stylable: false,
        })
        
        /*  relateClaimOnEditor[j].replaceWith(
          <sup claim-id={item.claimName}>{symbol}</sup>
        ); */
      }
    }
    // console.log(
    //   "editor html content",
    //   editor?.getWrapper().find(`[parent-claim=${claim.claimName}]`)
    // );
    for (var i = 0; i < claimParentOnEditor.length; i++) {
      const symbolElements = editor
        ?.getWrapper()
        .find(`[claim-id=${item.claimName}]`);
      if (symbolElements.length > 0) {
        for (var j = 0; j < symbolElements.length; j++) {
          
          const styleObj = symbolElements[j].getStyle();
          symbolElements[j].replaceWith(
            {
          tagName: "sup",
          attributes: {
            "claim-id": item.claimName,
            
          },
          style: styleObj,
          content: symbol,
           editable: false, // prevents editing the sup element itself
          selectable: true, // allows selecting
          hoverable: true,
          stylable: false,
        }
          )
         
          /* symbolElements[j].replaceWith(
            <sup claim-id={item.claimName}>{symbol}</sup>
          ); */
        }
      } else {
        claimParentOnEditor[i].append({
          tagName: "sup",
          attributes: {
            "claim-id": item.claimName,
            
          },
          style: {
            display: "none",
          },
          content: symbol,
           editable: false, // prevents editing the sup element itself
          selectable: true, // allows selecting
          hoverable: true,
          stylable: false,
        });
        
      }
    }
    // setOpenAssignPopup(false);
    finalAssignment([...relatedClaimsData]);
  };

  const finalAssignment = (payObj) => {
    const payLoad = {
      relatedClaimsData: payObj,
    };
    // console.log("finllllllllllllllllllllllllll", pageId, payLoad);
    updatSlideData(pageId, payLoad, (response, err, errorCode) => {
      if (err) {
        // setIsloading(false);
      } else {
        // setIsloading(false);
        // console.log("====res", response);
        setRelatedClaimsData(response.data.relatedClaimsData);
        setOpenAssignPopup(false);
        setPreviewLoading(false);
      }
    });
  };

  const closePopup = () => {
    setPreviewLoading(true);
    const obj = {
      relatedClaimId: item.claimName,
      text: "",
      symbol: appliedSymbol,
      claimId: claim.claimName,
      moduleId: moduleClaimsData?.moduleDamName,
    };
    const claimExistArray = relatedClaimsData?.findIndex(
      (exist_claim) =>
        exist_claim.relatedClaimId === obj.relatedClaimId &&
        exist_claim.moduleId === obj.moduleId
    );
    if (claimExistArray > -1) {
      relatedClaimsData[claimExistArray] = obj;
    } else {
      //relatedClaimsData.push(obj);
    }
    cancelPopup(appliedSymbol);
    setPreviewLoading(false);
    /* if (clickedSymbols !== null) {
      // finalAssignment([...relatedClaimsData]);
    } else {
      cancelPopup(appliedSymbol)
      setPreviewLoading(false);
    } */

    /* setRelatedClaimsData([...relatedClaimsData])  
    cancelPopup(appliedSymbol) */
  };
  return (
    <div className="assign-container">
      <div className="head-content">
        <div className="head-msg">
          <div className="head-css">ASSIGN CLAIM SYMBOL</div>
        </div>
      </div>
      <div className="actual-content d-flex">
        {/*   <div className="claims-section">                    
                </div>
                <div className="claims-content"></div>
                <div className="symbols"></div> */}
        {updateList &&
          !previewLoading &&
          footnoteSymbols.map((icons, index) => (
            <div
              className={`icons-css ${
                icons === clickedSymbols ? "clicked-symbols" : ""
              } ${
                relatedClaimsData.findIndex(
                  (data) =>
                    data.symbol === icons && data.symbol !== clickedSymbols
                ) > -1
                  ? "not-allowed-icon"
                  : ""
              }`}
              onClick={(e) => {
                selectSymbol(icons);
                // assignSymbolsHandler(icons);
              }}
              disabled={
                relatedClaimsData.findIndex(
                  (data) =>
                    data.symbol === icons && data.symbol !== clickedSymbols
                ) > -1
                  ? "true"
                  : "false"
              }
              style={{
                paddingTop:
                  index === 15 || index === 16
                    ? "14px"
                    : index === 31
                    ? "7px"
                    : index === 1
                    ? "8px"
                    : index === 0
                    ? "24px"
                    : "0px",
                fontSize:
                  icons === "***" || icons === "**"
                    ? "28px"
                    : icons === "†"
                    ? "40px"
                    : icons === "*"
                    ? "52px"
                    : "28px",
                fontWeight:
                  icons === "△" ||
                  icons === "~" ||
                  icons === "ǂ" ||
                  icons === "£"
                    ? "700"
                    : "500",
                letterSpacing: icons === "∥∥" && "-1.9px",
                fontFamily: [
                  "I",
                  "II",
                  "III",
                  "IV",
                  "V",
                  "VI",
                  "VII",
                  "VIII",
                  "IX",
                  "X",
                ].includes(icons)
                  ? `"Times New Roman', serif"`
                  : `"Nunito Sans", sans-serif`,
              }}
            >
              {icons}
            </div>
          ))}
      </div>
      <div className="foot-content">
        {/* <div className="shadow-line"></div> */}
        <div className="btn-section">
          <div>
            <button
              className="cancel-btn"
              onClick={() => closePopup(clickedSymbols)}
            >
              CANCEL
            </button>{" "}
            {/* class="details-informations-close" */}
          </div>
          <div>
            <button
              className={`assign-btn ${
                clickedSymbols !== null ? "active-assign" : ""
              }`}
              onClick={() => {
                assignSymbolsHandler(clickedSymbols);
              }}
              disabled={clickedSymbols !== null ? false : true}
            >
              ASSIGN
            </button>{" "}
            {/* disabled="" class="details-informations-update" */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AssignsymbolPopup;
